/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Response schema for zipcode validation endpoint.
 */
export interface ZipcodeValidationResponse {
  /** The validated ZIP code */
  zip_code: string;
  /** True if ZIP code is valid, False otherwise */
  is_valid: boolean;
  /** State abbreviation */
  state?: string | null;
}
